export default {
  siteName: 'Admin',
  // copyright: `COPYRIGHT &copy; ${new Date().getFullYear()} Eyas, All rights Reserved`,
  maker: 'Eyas Liu Made With',
  backToHome: 'Back To Home',
}